export default __webpack_public_path__ + "static/media/ArrowGreenDown.8c361c34.svg";